<template>
  <div class="app-container">
    <BjRouteTabs />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :search-btn-span="24"
      label-width="120px"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item label="单据号">
            <BjInputCode
              v-model="queryParams.queryCode"
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <BjSelectChannelStore
          :span="colSpan"
          :query-params="queryParams"
          :query-props="['channelTypeCode', 'shopIdList']"
          multiple
        />
        <el-col :span="colSpan">
          <el-form-item label="买家昵称">
            <BjInput
              v-model="queryParams.buyNick"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="出库状态">
            <BjSelectLov
              v-model="queryParams.status"
              :option-list="ORDER_STOCK_OUT_TYPE_LIST"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="发货仓库">
            <BjSelectWarehouse
              v-model="queryParams.outLogicWarehouseCode"
              :type-code="['logic']"
              value-code="code"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="出库单创建时间" prop="">
            <el-date-picker
              v-model="queryParamsTime_create"
              class="full-width"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="$pickerOptions()"
              align="right"
              :start-placeholder="$t('form.startDateText')"
              :end-placeholder="$t('form.endDateText')"
              :default-time="['00:00:00', '23:59:59']"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item label="物流业务">
            <BjSelectLogisticBusiness v-model="queryParams.logisticBusinessId" /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="物流单号">
            <BjInputCode
              v-model="queryParams.logisticsNo"
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="获取物流单号">
            <BjSelectLov
              v-model="queryParams.waybillStatus"
              lov-code="STOCK.ODO_WAYBILL_STATUS"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="面单打印状态">
            <BjSelectLov
              v-model="queryParams.waybillPrintStatus"
              :option-list="LOGISTICS_WAYBILL_PRINT_STATUS__LIST"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="商品名称/编码">
            <BjInput
              v-model="queryParams.spu"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuCode')">
            <BjInput
              v-model="queryParams.skuCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="SKU种类数">
            <el-row>
              <el-col :span="11">
                <el-input-number
                  v-model="queryParams.skuTypeMin"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                  class="full-width"
                />
              </el-col>
              <el-col class="text-center" :span="2">-</el-col>
              <el-col :span="11">
                <el-input-number
                  v-model="queryParams.skuTypeMax"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                  class="full-width"
                />
              </el-col>
            </el-row> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="商品数量">
            <el-row>
              <el-col :span="11">
                <el-input-number
                  v-model="queryParams.skuQtyMin"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                  class="full-width"
                />
              </el-col>
              <el-col class="text-center" :span="2">-</el-col>
              <el-col :span="11">
                <el-input-number
                  v-model="queryParams.skuQtyMax"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                  class="full-width"
                />
              </el-col>
            </el-row> </el-form-item
        ></el-col>
      </template>
      <template v-slot:seniorForm>
        <el-col :span="colSpan">
          <el-form-item label="出库类型">
            <BjSelectLov v-model="queryParams.outType" lov-code="STOCK.OUT_TYPE" /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="收件姓名">
            <BjInput
              v-model="queryParams.receiverName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <BjFormItemMobile
            v-model="queryParams.receiverPhone"
            prop="receiverPhone"
            label="收件手机"
            clearable
        /></el-col>
        <el-col :span="colSpan">
          <el-form-item label="收件省份" prop="receiverProvinceCode">
            <BjSelectChinaArea
              v-model="queryParams.receiverProvinceCode"
              class="full-width"
              @change="onChangeProvince"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="买家备注">
            <el-row>
              <el-col :span="8">
                <BjSelectLov v-model="queryParams.buyMsgFlag" :option-list="STATUS_HAVE_TRUE" />
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="15">
                <BjInput v-model="queryParams.buyMsg" :maxlength="MAX_LENGTH.REMARK" clearable />
              </el-col>
            </el-row> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="客服备注">
            <el-row>
              <el-col :span="8">
                <BjSelectLov v-model="queryParams.orderMsgFlag" :option-list="STATUS_HAVE_TRUE" />
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="15">
                <BjInput v-model="queryParams.orderMsg" :maxlength="MAX_LENGTH.REMARK" clearable />
              </el-col>
            </el-row> </el-form-item
        ></el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            type="primary"
            class="main-btn"
            :disabled="tableOperationProp.notSelected"
            @click="onPrint"
            >打印面单</el-button
          >
          <el-button
            type="primary"
            :disabled="tableOperationProp.notSelected"
            @click="onShowDialog('batchSendStock')"
            >批量发货</el-button
          >
          <el-button
            type="primary"
            :disabled="tableOperationProp.notSelected"
            @click="onShowDialog('getLogisticsNo')"
            >获取物流单号</el-button
          >
          <el-button type="primary" :disabled="tableOperationProp.notSingle" @click="onForceDeliver"
            >强制发货</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="{ row }">
              <template v-if="false" />
              <span v-else-if="col.prop === 'code'" class="link" @click="onView(row)">
                {{ row[col.prop] }}
              </span>
              <template v-else-if="col.prop === 'status'">
                {{ $t(ORDER_STOCK_OUT_TYPE_LIST.bjGet(row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'waybillStatusMeaning'">
                {{ row[col.prop] }}
                {{ row.waybillStatus !== 'GETED' ? row.waybillMessage : '' }}
              </template>
              <el-tag
                v-else-if="col.prop === 'waybillPrintStatus'"
                :type="row[col.prop] ? 'success' : 'info'"
                >{{ $t(LOGISTICS_WAYBILL_PRINT_STATUS__LIST.bjGet(row[col.prop])) }}</el-tag
              >
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-button type="text" @click="onEdit(row)">编 辑</el-button>
              <el-button type="text" @click="onDelete(row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column> -->
        </template>
      </template>
    </BjPage>
    <!-- 添加模板 -->
    <!-- <DataForm ref="DataForm" @reFresh="reFresh" /> -->
    <!-- 获取物流单号、批量发货提示框 -->
    <Dialog ref="Dialog" />
    <!-- 打印面单打印设置提示框 -->
    <PrintDialog ref="PrintDialog" @reFresh="reFresh" />
    <!-- 发货组件 -->
    <DeliverGoodsDialog ref="DeliverGoods" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
import {
  STATUS_HAVE_TRUE,
  LOGISTICS_WAYBILL_PRINT_STATUS__LIST,
  ORDER_STOCK_OUT_TYPE_LIST,
} from '@/utils/constants';
// import { randomID } from '@/utils';
import Dialog from './components/Dialog.vue';
import PrintDialog from './components/PrintDialog.vue';
import DeliverGoodsDialog from '@/components/BjDeliverGoodsDialog';
import webSocket from '@/utils/websocket';
const defaultForm = () => {
  return {
    queryCode: null,
    channelTypeCode: null,
    shopIdList: null,
    buyNick: null,
    status: null,
    beginCreationDate: null,
    endCreationDate: null,
    logisticBusinessId: null,
    logisticsNo: null,
    waybillPrintStatus: null,
    spu: null,
    skuCode: null,
    skuTypeMin: undefined,
    skuTypeMax: undefined,
    skuQtyMin: undefined,
    skuQtyMax: undefined,
    outType: null,
    receiverName: null,
    receiverPhone: null,
    receiverProvince: null,
    receiverProvinceCode: null,
    buyMsgFlag: null,
    buyMsg: null,
    orderMsgFlag: null,
    orderMsg: null,
  };
};

export default {
  name: 'BusinessStockConsignIntimidate',
  components: { Dialog, PrintDialog, DeliverGoodsDialog },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_HAVE_TRUE,
      LOGISTICS_WAYBILL_PRINT_STATUS__LIST,
      ORDER_STOCK_OUT_TYPE_LIST,
      queryApi: stockApi.getOutboundDeliveryOrderWaybillsPage,
      // 查询参数
      queryParams: defaultForm(),
      labelsVersion: 2,
      labelList: [
        { label: '出库通知单号', prop: 'code', isCheck: true, disabled: false, width: 160 },
        {
          label: '客户订单号',
          prop: 'platformOrderCode',
          isCheck: true,
          disabled: false,
          width: 180,
        },
        { label: '内部订单号', prop: 'orderCode', isCheck: true, disabled: false, width: 160 },
        {
          label: '销售渠道',
          prop: 'channelTypeCodeMeaning',
          isCheck: true,
          disabled: false,
          width: 120,
        },
        { label: '销售店铺', prop: 'shopName', isCheck: true, disabled: false, width: 160 },
        {
          label: '物流业务',
          prop: 'logisticBusiness',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        { label: '物流单号', prop: 'logisticsNo', isCheck: true, disabled: false, width: 160 },
        {
          label: '获取物流单号',
          prop: 'waybillStatusMeaning',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        { label: '出库状态', prop: 'status', isCheck: true, disabled: false, width: 120 },
        {
          label: '面单打印状态',
          prop: 'waybillPrintStatus',
          isCheck: true,
          disabled: false,
          width: 120,
        },
        { label: '出库类型', prop: 'outTypeMeaning', isCheck: true, disabled: false, width: 160 },
        {
          label: '出库逻辑仓编码',
          prop: 'outLogicWarehouseCode',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        {
          label: '出库逻辑仓名称',
          prop: 'outLogicWarehouseName',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        { label: '需发货数量', prop: 'qty', isCheck: true, disabled: false, width: 90 },
        { label: '买家昵称', prop: 'sorBuyerNikeName', isCheck: true, disabled: false, width: 160 },
        {
          label: '收件人姓名',
          prop: 'receiverNameMask',
          isCheck: true,
          disabled: false,
          width: 100,
        },
        {
          label: '收件人手机',
          prop: 'receiverPhoneMask',
          isCheck: true,
          disabled: false,
          width: 100,
        },
        {
          label: '收件人地址',
          prop: 'addressMask',
          isCheck: true,
          disabled: false,
          width: 200,
        },
        { label: '买家备注', prop: 'buyMsg', isCheck: true, disabled: false, width: 160 },
        { label: '客服备注', prop: 'orderMsg', isCheck: true, disabled: false, width: 160 },
        // { label: this.$t('orderNewPatch.Ordered'), prop: '', isCheck: true, disabled: false, width: 160 },
        // { label: '支付时间', prop: '', isCheck: true, disabled: false, width: 160 },
        {
          label: '出库单创建时间',
          prop: 'creationDate',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
      ],
      queryParamsTime_create: [],
      socket: null,
      // printerData: {
      //   cmd: 'getPrinters',
      //   defaultPrinter: '',
      //   printers: [],
      //   requestID: '',
      // },
      loading: null,
    };
  },
  computed: {},
  watch: {
    queryParamsTime_create(v) {
      this.queryParams.beginCreationDate = (v || [])[0];
      this.queryParams.endCreationDate = (v || [])[1];
    },
  },
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams = defaultForm();
      this.queryParamsTime_create = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 跳转 */
    onView(row) {
      this.$toBusinessStockDeliveryInformView(row.odoId);
    },
    onChangeProvince(v, item) {
      this.queryParams.receiverProvince = item.name;
    },
    /** 打印面单 */
    onPrint(row) {
      if (this.selectedRows.filter(e => !e.logisticsNo).length !== 0) {
        this.msgError('存在物流单号为空单据，无法打印');
        return;
      }
      stockApi
        .printToOutboundDeliveryOrderWaybills({
          printList: this.selectedRows.map(e => e.odoId),
        })
        .then(res => {
          if (res.printDatas.length) {
            this.getWebSocket(res.printDatas);
          }
        });
    },
    onShowDialog(type) {
      const API = type + 'ToOutboundDeliveryOrderWaybills';
      if (type === 'batchSendStock') {
        if (this.selectedRows.filter(e => !e.logisticsNo).length) {
          this.msgError('提交发货的订单必须有物流单号，请先获取物流单号');
          return;
        }
        if (this.selectedRows.filter(e => ![0, 1].includes(e.status)).length) {
          this.msgError('单据状态不正确，请刷新后重试');
          return;
        }
        const content = this.selectedRows.filter(e => !e.waybillPrintStatus).length
          ? '存在未打印的订单，请仔细确认面单打印结果！是否继续发货？'
          : '确认发货？';
        this.$MessageBox({ content }).then(res => {
          this.sendApi(API, '批量发货', () => {
            setTimeout(() => {
              this.reFresh();
            }, 500);
          });
        });
      } else {
        this.sendApi(API, '获取物流单号', () => {
          this.reFresh();
        });
      }
    },
    /** 强制发货 */
    onForceDeliver(row) {
      const { status, code, orderCode } = this.selectedRows[0];
      // [1, '待出库'],[0, '待通知WMS'],
      if (status === 0 || status === 1) {
        // 传入出库通知单号和内部订单号
        this.$refs.DeliverGoods.show(code, orderCode);
      } else {
        this.msgError('请选择待出库单据操作');
      }
    },
    getWebSocket(printDatas) {
      if (!webSocket.socket) {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
        });
        webSocket.init(res => {
          if (res.cmd === 'getPrinters') {
            this.$refs.PrintDialog.show(webSocket.printerData, printDatas);
          }
          if (res.cmd === 'PrintResultNotify') {
            if (res.taskStatus === 'printed') {
              this.$refs.PrintDialog.hide();
              this.reFresh();
            }
          }
        });
      } else {
        this.$refs.PrintDialog.show(webSocket.printerData, printDatas, this.socket);
      }
    },
    sendApi(API, content, callback) {
      const ids = this.selectedRows.map(e => e.odoId);
      stockApi[API]({ ids }).then(res => {
        this.$refs.Dialog.show(res, content);
        if (callback) callback();
      });
    },
  },
};
</script>
